export const IMMEDIATE_NURSE_CONSULT_TRACKING_ID = 'immediateNurseConsultTrackingPayload';

export const IMMEDIATE_NURSE_CONSULT_SMS_LOCAL_STORAGE_KEY = 'immediateNurseConsultSmsVerification';
